import React, { useState } from 'react';
import './NavigationCategoriesManagement.css';

/**
 * 🧭 NAVIGATION CATEGORIES MANAGEMENT COMPONENT 2025
 * 
 * Toggle-Sektion für Fancy Footer Navigation Categories nach Design-Guide:
 * - 1:1 Text-Edit-Design
 * - Navigation Categories mit Links-Verwaltung
 * - Add/Remove-Funktionalität für Categories und Links
 * - Spezifische Klassennamen für Navigation
 */
function NavigationCategoriesManagement({
    categories,
    addCategory,
    removeCategory,
    updateCategoryTitle,
    addLinkToCategory,
    removeLinkFromCategory,
    updateCategoryLink,
    editData
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="navigation-categories-management">
            {/* Toggle Header */}
            <div 
                className={`navigation-categories-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="navigation-categories-header-content">
                    <div className="navigation-categories-header-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M2 4h12M2 8h8M2 12h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <h3 className="navigation-categories-header-title">Navigation Categories</h3>
                    <div className="navigation-categories-counter">
                        {categories?.length || 0}
                    </div>
                </div>
                <div className={`navigation-categories-toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content */}
            {isExpanded && (
                <div className="navigation-categories-content">
                    {/* Add Category Button */}
                    <div className="add-category-section">
                        <button onClick={addCategory} className="add-category-btn">
                            <div className="btn-icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M7 3V11M3 7H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <span>Add Navigation Category</span>
                        </button>
                    </div>

                    {/* Categories Grid */}
                    {categories && categories.length > 0 && (
                        <div className="categories-grid">
                            {categories.map((category, categoryIndex) => (
                                <div key={category.id || categoryIndex} className="category-edit-card">
                                    <div className="category-edit-content">
                                        {/* Category Header */}
                                        <div className="category-edit-header">
                                            <div className="category-number">
                                                <span>{categoryIndex + 1}</span>
                                            </div>
                                            <button
                                                onClick={() => removeCategory(categoryIndex)}
                                                className="category-remove-btn"
                                                title="Remove Category"
                                            >
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                                </svg>
                                            </button>
                                        </div>

                                        {/* Category Title Input */}
                                        <div className="category-title-input">
                                            <input
                                                type="text"
                                                value={category.title || ''}
                                                onChange={(e) => updateCategoryTitle(categoryIndex, e.target.value)}
                                                placeholder="Category Title"
                                                className="category-title-field"
                                            />
                                        </div>

                                        {/* Links Management */}
                                        <div className="category-links-section">
                                            <div className="links-header">
                                                <span className="links-label">Links ({(category.links || []).length})</span>
                                                <button
                                                    onClick={() => addLinkToCategory(categoryIndex)}
                                                    className="add-link-btn"
                                                    title="Add Link"
                                                >
                                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <path d="M6 2V10M2 6H10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                                    </svg>
                                                </button>
                                            </div>

                                            {/* Links List */}
                                            {(category.links || []).map((link, linkIndex) => (
                                                <div key={linkIndex} className="link-edit-row">
                                                    <div className="link-inputs">
                                                        <input
                                                            type="text"
                                                            value={link.text || ''}
                                                            onChange={(e) => updateCategoryLink(categoryIndex, linkIndex, 'text', e.target.value)}
                                                            placeholder="Link Text"
                                                            className="link-text-input"
                                                        />
                                                        <input
                                                            type="text"
                                                            value={link.url || ''}
                                                            onChange={(e) => updateCategoryLink(categoryIndex, linkIndex, 'url', e.target.value)}
                                                            placeholder="Link URL"
                                                            className="link-url-input"
                                                        />
                                                    </div>
                                                    <button
                                                        onClick={() => removeLinkFromCategory(categoryIndex, linkIndex)}
                                                        className="link-remove-btn"
                                                        title="Remove Link"
                                                    >
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                            <path d="M7.5 2.5L2.5 7.5M2.5 2.5L7.5 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                                        </svg>
                                                    </button>
                                                </div>
                                            ))}

                                            {/* Empty Links State */}
                                            {(!category.links || category.links.length === 0) && (
                                                <div className="empty-links-state">
                                                    <span>No links yet - click + to add</span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {(!categories || categories.length === 0) && (
                        <div className="empty-state">
                            <div className="empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <path d="M6 12h36M6 24h24M6 36h30" stroke="#d1d5db" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <h4>No Navigation Categories Yet</h4>
                            <p>Add categories like "Services", "Company", "Support" with their respective links.</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default NavigationCategoriesManagement;
